// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inscribe {
  min-height: 100vh;
  background: #e7eef2;
  color: #102033;
  font-family: Outfit, Inter, sans-serif;
}

.inscribe__band {
  background: #0877bc;
  color: #f7fbff;
  padding: 0.85rem 1.2rem;
}

.inscribe__band p {
  margin: 0;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 0.78rem;
}

.inscribe__sheet {
  width: min(640px, calc(100% - 1.5rem));
  margin: 1.25rem auto 2rem;
  background: #f7fafc;
  border: 1px solid #d5deea;
  padding: 1.25rem 1.2rem 1.5rem;
}

.inscribe__sheet h1 {
  margin: 0 0 0.6rem;
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  line-height: 1.05;
  letter-spacing: -0.03em;
}

.inscribe__table {
  height: 8px;
  margin: 0 0 1rem;
  background:
    linear-gradient(#f7fafc, #f7fafc) center / 2px 100% no-repeat,
    #1f8a4c;
}

.inscribe__facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem;
  list-style: none;
  margin: 0 0 1.2rem;
  padding: 0;
}

.inscribe__facts span {
  display: block;
  color: #5c6b7a;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.inscribe form,
.inscribe label {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.inscribe form {
  gap: 0.75rem;
}

.inscribe input {
  font: inherit;
  padding: 0.65rem 0.7rem;
  border: 1px solid #c5d0dc;
  border-radius: 2px;
  background: white;
  color: inherit;
}

.inscribe__cats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem 1rem;
}

.inscribe__cats label {
  flex-direction: row;
  align-items: center;
}

.inscribe button {
  font: inherit;
  background: #102033;
  color: white;
  border: 0;
  padding: 0.8rem 1rem;
  cursor: pointer;
}

.inscribe button:focus-visible,
.inscribe input:focus-visible {
  outline: 2px solid #0877bc;
  outline-offset: 2px;
}

.inscribe__hp {
  position: absolute;
  left: -9999px;
  height: 0;
  overflow: hidden;
}

.inscribe__error {
  color: #9a3412;
}

.inscribe__ok {
  color: #166534;
}

.inscribe section ul {
  margin: 0.3rem 0 0;
  padding-left: 1.1rem;
}

@media (max-width: 640px) {
  .inscribe__sheet {
    margin-top: 0;
    border-left: 0;
    border-right: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/TournamentInscriptionPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB;;WAES;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".inscribe {\n  min-height: 100vh;\n  background: #e7eef2;\n  color: #102033;\n  font-family: Outfit, Inter, sans-serif;\n}\n\n.inscribe__band {\n  background: #0877bc;\n  color: #f7fbff;\n  padding: 0.85rem 1.2rem;\n}\n\n.inscribe__band p {\n  margin: 0;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-size: 0.78rem;\n}\n\n.inscribe__sheet {\n  width: min(640px, calc(100% - 1.5rem));\n  margin: 1.25rem auto 2rem;\n  background: #f7fafc;\n  border: 1px solid #d5deea;\n  padding: 1.25rem 1.2rem 1.5rem;\n}\n\n.inscribe__sheet h1 {\n  margin: 0 0 0.6rem;\n  font-size: clamp(1.8rem, 4vw, 2.5rem);\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n}\n\n.inscribe__table {\n  height: 8px;\n  margin: 0 0 1rem;\n  background:\n    linear-gradient(#f7fafc, #f7fafc) center / 2px 100% no-repeat,\n    #1f8a4c;\n}\n\n.inscribe__facts {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.75rem;\n  list-style: none;\n  margin: 0 0 1.2rem;\n  padding: 0;\n}\n\n.inscribe__facts span {\n  display: block;\n  color: #5c6b7a;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.inscribe form,\n.inscribe label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.inscribe form {\n  gap: 0.75rem;\n}\n\n.inscribe input {\n  font: inherit;\n  padding: 0.65rem 0.7rem;\n  border: 1px solid #c5d0dc;\n  border-radius: 2px;\n  background: white;\n  color: inherit;\n}\n\n.inscribe__cats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem 1rem;\n}\n\n.inscribe__cats label {\n  flex-direction: row;\n  align-items: center;\n}\n\n.inscribe button {\n  font: inherit;\n  background: #102033;\n  color: white;\n  border: 0;\n  padding: 0.8rem 1rem;\n  cursor: pointer;\n}\n\n.inscribe button:focus-visible,\n.inscribe input:focus-visible {\n  outline: 2px solid #0877bc;\n  outline-offset: 2px;\n}\n\n.inscribe__hp {\n  position: absolute;\n  left: -9999px;\n  height: 0;\n  overflow: hidden;\n}\n\n.inscribe__error {\n  color: #9a3412;\n}\n\n.inscribe__ok {\n  color: #166534;\n}\n\n.inscribe section ul {\n  margin: 0.3rem 0 0;\n  padding-left: 1.1rem;\n}\n\n@media (max-width: 640px) {\n  .inscribe__sheet {\n    margin-top: 0;\n    border-left: 0;\n    border-right: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
